var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    fill: "white",
    stroke: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6546 19.7502L39.5936 17.4054L37.2495 13.345H32.5607L28.4996 11.0003L24.4386 13.345H19.7498L17.4051 17.4061L13.3447 19.7502V24.439L11 28.5L13.3447 32.5611V37.2498L17.4058 39.5946L19.7505 43.6556H24.4393L28.4997 45.9998L32.5608 43.655H37.2496L39.5943 39.594L43.6554 37.2492V32.5605L46.0001 28.4994L43.6554 24.4384V19.7502H43.6546ZM26.9202 35.6625C26.5939 35.9888 26.164 36.1474 25.7361 36.1414C25.308 36.1475 24.8782 35.9888 24.5519 35.6625L19.4339 30.5444C18.7927 29.9033 18.7927 28.8632 19.4339 28.2221L20.7888 26.8672C21.4299 26.2261 22.47 26.2261 23.1111 26.8672L25.7361 29.4922L33.8878 21.3399C34.5289 20.6987 35.569 20.6987 36.2101 21.3399L37.565 22.6948C38.2061 23.3359 38.2061 24.376 37.565 25.0171L26.9202 35.6625Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/icon10.ffbafd44c254895ebdf52a0ae45ab859.svg";
export { ForwardRef as ReactComponent };